import { Axios } from "../../service/serviceBasic";
import {
  SET_MESSAGE_CONFIRMACAOEMAIL,
  SET_LOADING_VALUE,
  SET_ERROR_VALUE,
} from "./types";
import { toast } from "react-toastify";

export const setMessageConfirmacaoEmailAction = (obj) => ({
  type: SET_MESSAGE_CONFIRMACAOEMAIL,
  payload: obj,
});

export const setLoadingValue = (flag) => ({
  type: SET_LOADING_VALUE,
  payload: flag,
});

export const checkConfirmationHashAction = (id) => (dispatch) => {
  dispatch(setLoadingValue(true));
  let screenInfo;

  return Axios.post("v1/cliente/cliente/confirmarEmail", {
    IdEnvioEmailConfirmacao: id,
  })
    .then((response) => {
      screenInfo = {
        icon: "fa-check-circle-o",
        title: "E-mail confirmado com sucesso!",
        discription:
          "Falta pouco para abrir a sua Conta na B&T Câmbio! Já recebemos a sua solicitação. Seus documentos estão em análise e agora é só aguardar.",
      };
    })
    .catch((error) => {
      screenInfo = {
        icon: "fa-times-circle-o",
        title: "Oops!",
        discription:
          "Não encontramos a solicitação de confirmação ou o email já foi confirmado.",
      };
      toast.warn("Tente novamente, ou dirija-se a uma loja da B&T Câmbio", {
        position: toast.POSITION.BOTTOM_RIGHT,
        className: "ui-alert-toast",
      });
    })
    .finally(() => {
      dispatch(setMessageConfirmacaoEmailAction(screenInfo));
      dispatch(setLoadingValue(false));
    });
};
